import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import {  useNavigate, useParams } from "react-router-dom"
import { useState } from "react"
import QuestionSetsList from './QuestionSetsList'
import { useGetCoursesQuery } from "../courses/coursesApiSlice"
function QuestionSetsListFilter() {
    const {groupId} = useParams()
    useTitle('geshtop-Exercise: QuestionSets List')
    const [course,setCourse] = useState()
    const [q,setQ] = useState('')


    const { courses } = useGetCoursesQuery("coursesList", {
        selectFromResult: ({ data }) => ({
            courses: data?.ids.map(id => data?.entities[id])
        }),
    })

    const navigate = useNavigate()
    const options = courses?.map(course => {
        return (
            <option
                key={course.id}
                value={course.id}
            >{course.name} </option >
        )
    })
   
   
    const content =(<>
    <div className="filter-form">
  
                    <div className="filter-form-item">

                    
                <select
                    id="course"
                    name="course"
                    className={`form__select `}
                    value={course}
                    onChange={(e)=>setCourse(e.target.value)}
                >
                    <option value="">Select Course</option>
                   {options}
                </select>

        </div>
        <div className="filter-form-item">
            <input className="form__input" onChange={(e)=>setQ(e.target.value)} />
            </div>
    </div>
 <QuestionSetsList  q={q}  course={course} />
</> ) 
  return content;
}

export default QuestionSetsListFilter